<template>
  <QueryView
    ref="queryView"
    :table-config="tableConfig"
    :town-selection="false"
    :region-selection="true"
    :province-selection="true"
    use-expansion
  >
    <template #expansion="{ data }">
      <div class="query__expansion-container">
        <div
          v-if="!!data?.description"
          class="query__expansion-field-container"
        >
          <span class="query__expansion-field-label">Descripción:</span>
          <span class="query__expansion-field-value">
            {{ data.description }}
          </span>
        </div>
        <div
          v-if="!!data?.poi"
          class="query__expansion-field-container"
        >
          <span class="query__expansion-field-label">Lugares de interés:</span>
          <span class="query__expansion-field-value">
            {{ data.poi }}
          </span>
        </div>
        <div
          v-if="!!data?.leisure"
          class="query__expansion-field-container"
        >
          <span class="query__expansion-field-label">Ocio:</span>
          <span class="query__expansion-field-value">
            {{ data.leisure }}
          </span>
        </div>
        <div
          v-if="!!data?.access"
          class="query__expansion-field-container"
        >
          <span class="query__expansion-field-label">Acceso:</span>
          <span class="query__expansion-field-value">
            {{ data.access }}
          </span>
        </div>
      </div>
    </template>
  </QueryView>
  <div
    :hidden="!dialogVisible"
    class="modal"
  >
    <div>
      <button
        class="close-button"
        @click="closeDialog"
      >
        <span class="material-icons">close</span>
      </button>
    </div>
    <DataView
      v-if="!!selectedIdStops"
      v-bind="tableStopsConfig"
      ref="dataView"
      class="dataViewClass"
    >
    </DataView>
  </div>
</template>

<script setup>
import {ref, computed} from 'vue';
import {useClipboard} from '@vueuse/core';
import QueryView from '../QueryView';
import QueryTableConfig from '../query-table.view-config.js';
import {GREEN_WAYS_SCHEMA} from './query-green-ways-table.view-config';
import {searchGreenWay} from '@/api/green-way/green-way.api';
import QueryStopsTableConfig from './query-green-ways-stops-table.view-config.js';
import {
  searchGreenWayHtml,
  searchGreenWayPdf,
  getGreenWayPdf,
} from '@/api/green-way/green-way.api.pdf.js';
import {DataView} from '@sttedra_ui/framework';
// #region Props, Emits

// #endregion

// #region Params, Ref, Reactives, Computed
const queryView = ref();
const dialogVisible = ref(false);
const {copy} = useClipboard();
const selectedIdStops = ref(0);

const tableStopsConfig = computed(() => {
  return new QueryStopsTableConfig({stopId: selectedIdStops.value});
});
// #endregion

// #region Functions
async function goGreenWay({coordinates, name, visible}) {
  const goCoordinates = queryView?.value?.goCoordinates;
  const zoom = 10;
  if (!!goCoordinates) {
    goCoordinates({coordinates, name, visible, zoom});
  }
}
function greenWayToText({
  name,
  description,
  route,
  routeSteps,
  province,
  poi,
  leisure,
  access,
}) {
  const sep = '\n      ';
  const routeString = sep + routeSteps.join(sep);
  const res = `
    Nombre: ${name}
    Descripción: ${description}
    Recorrido: ${route}
    Paradas: ${routeString}
    Provincia: ${province}
    Lugares de interés: ${poi}
    Ocio: ${leisure}
    Acceso: ${access}
    `;
  return res;
}
async function printGreenWay(data) {
  const printRecord = queryView?.value?.printRecord ?? null;
  if (!!printRecord) {
    await printRecord(data.id, 'Vía Verde - ' + data.name, getGreenWayPdf);
  }
}
async function htmlGreenWayQuery() {
  const printQuery = queryView?.value?.printQuery ?? null;
  if (!!printQuery) {
    await printQuery('Informe Vías verdes/Rutas Ciclistas', searchGreenWayHtml, 'html');
  }
}
async function printGreenWayQuery() {
  const printQuery = queryView?.value?.printQuery ?? null;
  if (!!printQuery) {
    await printQuery('Informe Vías verdes/Rutas Ciclistas', searchGreenWayPdf);
  }
}
async function viewStopsFunction(row) {
  dialogVisible.value = true;
  selectedIdStops.value = row.idVia;
}
function closeDialog() {
  dialogVisible.value = false;
  selectedIdStops.value = 0;
}
// #endregion
// printQuery previously defined
const tableConfig = new QueryTableConfig({
  title: '',
  api: searchGreenWay,
  recordToText: greenWayToText,
  copyClipboard: copy,
  htmlQuery: htmlGreenWayQuery,
  printQuery: printGreenWayQuery,
  printRecord: printGreenWay,
  centerMap: goGreenWay,
  viewStops: viewStopsFunction,
  schema: GREEN_WAYS_SCHEMA,
});

// #region Effects, Hooks

// #endregion

// #region Provide, Expose

// #endregion
</script>

<style lang="scss" scoped>
.modal {
  background-color: white;
  padding: 1rem;
  border-radius: 5px;
  position: fixed;
  right: 35%;
  bottom: 20%;
  top: 20%;
  left: 35%;
  z-index: 100;
  box-shadow: 0 1px 4px rgba($brand__color--black, 0.2);
  @media only screen and (max-width: 670px) {
    right: 3%;
    bottom: 15%;
    top: 15%;
    left: 3%;
  }
}
.close-button {
  float: right;
  cursor: pointer;
  border: none;
  color: rgba($brand__color--blue, 0.8) !important;
  background-color: transparent;
}
.dataview__table--wrap-normal :deep(td.data-view-table__field) {
  white-space: normal;
}
.p-dialog.p-component {
  padding: 7rem;
  & :deep(.p-component.p-dialog-content) {
    padding: 0rem;
  }
}
.dataViewClass {
  & :deep(.paginator) {
    display: none;
  }
  & :deep(.data-view__info__sort-by) {
    display: none;
  }
  & :deep(.data-view__header__after) {
    display: none;
  }
  & :deep(.data-view__header) {
    display: none;
  }
  & :deep(.p-resizable-column) {
    display: none;
  }
  & :deep(.smart-content__title) {
    padding-top: 0rem;
    padding-bottom: 0rem;
  }
  & :deep(.data-view-table__field) {
    white-space: normal;
    padding: 0.6rem;
    line-height: 1.5em;
    height: 3em;
  }
}
</style>
